import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-20 bg-white" data-id="element-218">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-220">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy text-center mb-10" data-id="element-221">
            La Verdad que Nadie te Dice
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-222">
            <p data-id="element-223">
              La mayoría de los expertos te dicen que medites una hora o que te
              vayas a vivir al campo. Seamos honestos: tienes cuentas que pagar
              y no tienes una hora libre.
            </p>

            <p className="font-bold text-xl text-navy" data-id="element-224">
              Necesitas una solución TÁCTICA.
            </p>

            <p data-id="element-225">
              El secreto no es eliminar el estrés (Santiago no va a dejar de ser
              ruidoso), sino hackear tu respuesta biológica al entorno. Se trata
              de aprender a engañar a tu cerebro para que baje el cortisol
              mediante Ventanas de Recuperación de 3 minutos aplicables en
              cualquier lugar: el Metro, el baño de la oficina o el taco de las
              7 PM.
            </p>

            <div className="text-center mt-10" data-id="element-226">
              <span className="inline-block bg-navy text-white font-bold text-xl py-4 px-8 rounded-lg shadow-md" data-id="element-227">
                No necesitas más tiempo. Necesitas el sistema correcto.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}